<template>
  <div :class="['chip-wrapper', theme, { 'has-icon': hasIcon }, { hide: !state.show }]">
    <div class="chip-content flex-inline">
      <slot name="icon" />
      <div class="chip-text">
        {{ text }}
      </div>
      <button class="button-icon" :aria-label="ariaLabel" @click="chipCloser" />
    </div>
  </div>
</template>

<script setup lang="ts">
type ChipEmits = 'click-button';

const emit = defineEmits(['click-button']);

const props = defineProps({
  emitClick: {
    type: String as () => ChipEmits,
    default: undefined,
  },
  theme: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  hasIcon: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: 'Remove item',
  },
});

const state = reactive({
  show: true,
});

function chipCloser() {
  state.show = false;
  if (props.emitClick) emit(props.emitClick, props.text);
}
</script>

<style scoped lang="scss">
.chip-wrapper {
  display: flex;
  align-items: center;
  border-radius: 16px;
  height: 28px;

  .chip-content {
    margin: 8px 12px;
  }

  .icon-wrapper {
    margin-right: 4px;

    &.account-circle {
      @include local-mixins.backgroundMaskImage(local-functions.svg-img-source('account-circle-line.svg'));
    }
  }

  .chip-text {
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 8px;
    text-align: center;
  }

  .button-icon {
    border: none;
    background: none;
    padding: 0;
    margin-left: 10px;
    @include local-mixins.backgroundMaskImage(local-functions.svg-img-source('close-fill.svg'), '', 14px, 14px);
  }

  &.has-icon {
    .button-icon {
      margin-left: 4px;
    }
  }

  &.hide {
    display: none;
  }

  &.primary,
  &.primary button {
    background-color: $color-primary-50;
    color: $color-primary-600;

    .icon-wrapper,
    .button-icon {
      background-color: $color-primary-600;
    }
  }

  &.secondary,
  &.secondary button {
    background-color: $color-secondary-50;
    color: $color-secondary-600;

    .icon-wrapper,
    .button-icon {
      background-color: $color-secondary-600;
    }
  }

  &.neutralgrey,
  &.neutralgrey button {
    background-color: $color-neutral-cool-50;
    color: $color-neutral-cool-600;

    .icon-wrapper,
    .button-icon {
      background-color: $color-neutral-cool-600;
    }
  }
}
</style>
